<template>
  <div class="row">
    <div class="col-sm-12" :class="{ 'col-md-6 col-xl-9': showAdvanced }">
      <div class="w-100">
        <h1>Business Verification</h1>
        <scheme-business-verification-toolbar @advanced-search="toggleAdvancedSearch" />
        <scheme-business-verification-search-table ref="schemeBusinessVerificationTable" />
      </div>
    </div>
    <div v-if="showAdvanced" class="col-sm-12 col-md-6 col-xl-3">
      <scheme-business-verification-search-advanced
        @error-message-changed="showErrorMessage"
        @reset-requested="reset"
        @close="toggleAdvancedSearch"
      />
    </div>
  </div>
</template>

<script>
import SchemeBusinessVerificationSearchTable from './SchemeBusinessVerificationSearchTable.vue';
import SchemeBusinessVerificationToolbar from './SchemeBusinessVerificationToolbar.vue';
import SchemeBusinessVerificationSearchAdvanced from './SchemeBusinessVerificationSearchAdvanced.vue';

export default {
  name: 'SchemeBusinessVerificationList',
  components: {
    SchemeBusinessVerificationSearchTable,
    SchemeBusinessVerificationToolbar,
    SchemeBusinessVerificationSearchAdvanced,
  },
  emits: ['toggle-advanced-search-business-verification'],
  data() {
    return {
      showAdvanced: false,
    };
  },
  methods: {
    toggleAdvancedSearch() {
      this.showAdvanced = !this.showAdvanced;
      this.emitter.emit('toggle-advanced-search-business-verification', this.showAdvanced);
    },
    showErrorMessage(msg) {
      this.$refs.schemeBusinessVerificationTable.changeErrorMessage(msg);
    },
    reset() {
      this.$refs.schemeBusinessVerificationTable.reset();
    },
  },
};
</script>
